export default "__VITE_ASSET__f69cfd31__"